import React from "react";

import styles from './ToastBody.module.scss';

const ToastBody = ({text}) => (
    <div className={styles.toast}>{text.split('\n').map(item => <p>{item}</p>)}</div>
);

export default ToastBody;